import React from 'react';
import hljs from 'highlight.js/lib/core';
import xml from 'highlight.js/lib/languages/xml';
import 'highlight.js/styles/default.css';

hljs.registerLanguage('html', xml);
const codeStyle = { backgroundColor: 'transparent' };

export const HtmlHighlight = ({ content }) => {
    const html = React.useMemo(
        () => ({ __html: content ? hljs.highlight(content, { language: 'html' }).value : null }),
        [content]
    );
    return (
        <pre>
            <code className="hljs" dangerouslySetInnerHTML={html} style={codeStyle} />
        </pre>
    );
};
